import { motion } from 'framer-motion';
const bible = require("../assets/bible.jpeg");
const unreached = require("../assets/unreached.jpeg");
const orphans = require("../assets/orphans.jpeg");
const medical= require("../assets/medical.jpeg")
const empowerment = require("../assets/projects.jpeg")

const impactAreas = [
  {
    title: "Bibles & Leadership Development",
    description: "Equipping pastors and church leaders with Bibles and comprehensive training to effectively shepherd their congregations.",
    stats: ["500+ Bibles distributed", "12 conferences yearly", "300+ pastors trained"],
    image: bible,
    color: "bg-blue-100 text-blue-800"
  },
  {
    title: "Reaching the Unreached",
    description: "Bringing the Gospel to remote prisons and communities through evangelism and establishing new churches.",
    stats: ["15+ churches planted", "50+ villages reached", "Thousands hear Gospel"],
    image: unreached,
    color: "bg-purple-100 text-purple-800"
  },
  {
    title: "Medical Ministry",
    description: "Bringing medical care and Christ's healing to communities through clinics and health education.",
    stats: ["2 clinics established", "5,000+ patients treated", "HIV/AIDS programs"],
    image: medical,
    color: "bg-red-100 text-red-800"
  },
  {
    title: "Empowerment Projects",
    description: "Creating sustainable solutions through agriculture, micro-enterprise, and skills development.",
    stats: ["10+ farms established", "50 women in micro-loans", "Dairy cooperative"],
    image: empowerment,
    color: "bg-orange-100 text-orange-800"
  },
  {
    title: "Shalom Preparatory Schools",
    description: "TEACHING and Educating the next generation by Starting schools for children from kindergarten to high schools, polytechnics and technical trainings for youth's empowerment and business , girls educations from marginalized tribes and fight bad cultural abuse among girls like FGM - female mutulations.Mentorship and boys for Christ sports.",
    stats: ["200+ orphans supported", "5 schools established", "500+ children educated"],
    image: orphans,
    color: "bg-green-100 text-green-800"
  },
];

const Impact = () => {
  return (
    <section className="py-3 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-2"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-3 font-serif">Transforming Lives Through Christ</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            See how God is working through our ministry to impact communities
          </p>
        </motion.div>

        {/* Impact Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-6">
          {impactAreas.map((area, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`group rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 ${
                // Apply col-span-2 on large screens when it's the last item and total items are odd
                index === impactAreas.length - 1 && impactAreas.length % 3 === 1 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={area.image} 
                  alt={area.title}
                  className="w-full h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 bg-white">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{area.title}</h3>
                <p className="text-gray-600 mb-4">{area.description}</p>
                <ul className="space-y-2 mb-5">
                  {area.stats.map((stat, i) => (
                    <li key={i} className="flex items-start">
                      <div className={`w-2 h-2 rounded-full mt-2 mr-2 ${area.color.replace('100', '500')}`}></div>
                      {/* <span className="text-gray-700 text-sm">{stat}</span> */}
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Impact;